import { defineStyleConfig } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'

const { FontColor } = themeColorSectionKeys.defaults

export const HighlightStyle = defineStyleConfig({
  baseStyle: {
    bg: FontColor.Highlight,
    px: '0',
    py: '0',
    color: 'inherit',
  },
})
